import { UserRoles as CommonUserRoles } from '../common/enums/UserRoles'

export class UserRoles extends CommonUserRoles {
  static GUARD = 'guard'
  static MANAGEMENT_BUILDING = 'management_building'
}
